// removed by extract-text-webpack-plugin
module.exports = {"effectiveDate":"_1hGKdpZygL"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/legal/PageHeader/PageHeader.module.less
// module id = 967
// module chunks = 3